import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { CardWrapper } from 'foundations-components/transitional/components/Card';
import { LoadingButton } from 'foundations-components/transitional/components/LoadingButton';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import { Tag } from 'foundations-components/transitional/components/Tag';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import UsageTracker from '../../../utils/UsageTracker';
import { useRegisterForSession, useCancelRegistration } from '../liveEventQueries';
import { getSessionEndTime, getSessionStartTime } from '../sessionTimeUtils';
import SessionDateDisplay from './SessionDateDisplay';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SessionCard = ({
  isRegistered,
  liveEventId,
  onRegistered,
  session
}) => {
  const startTime = getSessionStartTime(session);
  const endTime = getSessionEndTime(session);
  const {
    isMobile
  } = useMediaQuery();
  const {
    registerForSession,
    registrationLoading
  } = useRegisterForSession({
    onCompleted: onRegistered,
    onError: () => {
      FloatingAlertStore.addAlert({
        type: 'danger',
        message: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "academyComponents.liveEventOverviewModal.registrationError"
        })
      });
    }
  });
  const {
    cancelRegistration,
    cancellationLoading
  } = useCancelRegistration({
    onError: () => {
      FloatingAlertStore.addAlert({
        type: 'danger',
        message: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "academyComponents.liveEventOverviewModal.cancelRegistrationError"
        })
      });
    }
  });
  const handleRegister = () => {
    UsageTracker.trackStandalone('Learning Center Interaction', {
      action: 'live-event-register-click',
      contentType: 'LIVE_EVENT',
      contentId: liveEventId,
      sessionId: session.id
    });
    void registerForSession(session.id);
  };
  const handleCancel = () => {
    UsageTracker.trackStandalone('Learning Center Interaction', {
      action: 'live-event-cancel-registration-click',
      contentType: 'LIVE_EVENT',
      contentId: liveEventId,
      sessionId: session.id
    });
    void cancelRegistration(session.id);
  };
  return /*#__PURE__*/_jsx(CardWrapper, {
    padding: "800",
    children: /*#__PURE__*/_jsxs(Flex, {
      alignItems: isMobile ? 'start' : 'center',
      flexDirection: isMobile ? 'column' : 'row',
      gap: "400",
      justifyContent: "space-between",
      children: [/*#__PURE__*/_jsxs(Flex, {
        alignItems: "center",
        gap: "200",
        children: [/*#__PURE__*/_jsx(Text, {
          typography: "heading-50",
          children: /*#__PURE__*/_jsx(SessionDateDisplay, {
            endTime: endTime,
            startTime: startTime
          })
        }), isRegistered && /*#__PURE__*/_jsx(Tag, {
          inline: true,
          margin: "0",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "academyComponents.liveEventOverviewModal.registered"
          })
        })]
      }), isRegistered ? /*#__PURE__*/_jsx(LoadingButton, {
        loading: cancellationLoading,
        onClick: handleCancel,
        use: "tertiary-light",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "academyComponents.liveEventOverviewModal.cancelRegistration"
        })
      }) : /*#__PURE__*/_jsx(LoadingButton, {
        loading: registrationLoading,
        onClick: handleRegister,
        use: "secondary",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "academyComponents.liveEventOverviewModal.registerForWorkshop"
        })
      })]
    })
  });
};
export { SessionCard };